import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../css/dashboardIA.css";

// Vista de tabla equivalente de CUALQUIER gráfica del tablero (RF-24/CA-10), plegada por defecto. Un solo
// componente reutilizado por todos los bloques con gráfica (Embudo, Estados, Clubhouse, TipoIA,
// Estrategia, Tier, Checklist, Vigilancia, Tendencia, Champions) — evita seis tablas escritas a mano.
const TablaDeDatos = ({ columnas, filas }) => {
  const [abierta, setAbierta] = useState(false);
  const [t] = useTranslation("dashboardIA");

  return (
    <div className="dia-tabladatos mt-2">
      <button
        type="button"
        className="dia-tabladatos__toggle"
        onClick={() => setAbierta((valor) => !valor)}
        aria-expanded={abierta}
      >
        <i className="fa fa-table mr-1" aria-hidden="true"></i>
        {abierta ? t("dashboardIA_tabla_ocultar") : t("dashboardIA_tabla_ver")}
      </button>
      {abierta && (
        <div className="table-responsive mt-2">
          <table className="table table-sm table-borderless dia-tabladatos__table mb-0">
            <thead>
              <tr>
                {columnas.map((columna) => (
                  <th key={columna.key}>{columna.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filas.map((fila, indiceFila) => (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={indiceFila}>
                  {columnas.map((columna) => (
                    <td key={columna.key}>{fila[columna.key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TablaDeDatos;
